import { clients } from '@moovly/clients';
import { ProjectCountBatch } from '@moovly/clients/lib/resources/projects/projects.interfaces';
import { UserBatchResponse } from '@moovly/clients/lib/resources/users/users.interfaces';
import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  DefaultApiRequestState,
  getDefaultApiRequestState,
  getDefaultReducerForAsyncRequest,
  RequestType,
} from '../../../store/default';

export interface IMetricData {
  start: Date;
  end: Date;
  value: number;
}

export const getUsers = createAsyncThunk<UserBatchResponse, { userIds: string[]; token?: string }>(
  'dashboard/users/getUsers',
  ({ userIds, token }) => {
    return clients.Users.getUsersBatch(userIds, token);
  }
);
export const getUsersProjectCount = createAsyncThunk<ProjectCountBatch[], { userIds: string[]; token?: string }>(
  'dashboard/users/getUsersProjectCount',
  ({ userIds, token }) => {
    return clients.Projects.getProjectCountsBatch(userIds, token);
  }
);

type UsersState = {
  users: DefaultApiRequestState<UserBatchResponse, [RequestType.Get]>;
  userProjectCounts: DefaultApiRequestState<ProjectCountBatch[], [RequestType.Get]>;
  userSearch: string | null;
};

const initialState: UsersState = {
  users: getDefaultApiRequestState([RequestType.Get], {}),
  userProjectCounts: getDefaultApiRequestState([RequestType.Get], []),
  userSearch: null,
};

export const usersSlice = createSlice({
  name: 'users',
  initialState,
  reducers: {
    reset: () => initialState,
    setSearch: (state, { payload }: PayloadAction<string | null>) => {
      state.userSearch = payload;
    },
  },
  extraReducers: {
    ...getDefaultReducerForAsyncRequest({
      thunk: getUsers,
      requestType: RequestType.Get,
      getInitialState: (state) => state.users,
      onSuccess: (state, payload: UserBatchResponse) => {
        state.data = {
          ...(state.data || {}),
          ...payload,
        };
      },
    }),
    ...getDefaultReducerForAsyncRequest({
      thunk: getUsersProjectCount,
      requestType: RequestType.Get,
      getInitialState: (state) => state.userProjectCounts,
      onSuccess: (state, payload: ProjectCountBatch[]) => {
        state.data = [...(state.data || []), ...payload];
      },
    }),
  },
});

export default usersSlice;
